import formatDate, { FormatDateOptions } from '@anm/helpers/date/formatDate';

const formatSubscriptionDate = (date: string, options?: FormatDateOptions) => {
  const [day, month, year] = date.split('/');

  if (!day || !month || !year) {
    throw new Error(`formatSubscriptionDate - incorrect date format: ${date}`);
  }

  return formatDate(`${month}/${day}/${year}`, options);
};

export default formatSubscriptionDate;
